import { apiPrefix } from "@/config/config";
import { api, authApi } from "../interceptor/api.interceptor";

class UserService {
  // Public routes
  static async sendOtp(data) {
    return await api
      .post(`/${apiPrefix}/send-otp`, data)
      .then((res) => res?.data?.data);
  }
  static async sendRegOtp(data) {
    return await api
      .post(`/${apiPrefix}/send-reg-otp`, data)
      .then((res) => res?.data?.data);
  }
  static async forgetPassword(data) {
    return await api
      .post(`/${apiPrefix}/forget-password`, data)
      .then((res) => res?.data?.data);
  }

  static async verifyOtp(data) {
    return await api
      .post(`/${apiPrefix}/verify-otp`, data)
      .then((res) => res?.data?.data);
  }

  static async register(data) {
    return await api
      .post(`/${apiPrefix}/register`, data)
      .then((res) => res?.data?.data);
  }

  static async login(data) {
    return await api.post(`/${apiPrefix}/login`, data).then((res) => res?.data);
  }
  
    static async direct_login(params) {
    return await authApi
      .get(`/${apiPrefix}/direct_login`, { params })
      .then((res) => res?.data)
      .catch((err) => {
        console.error("Failed to fetch User token:", err);
        throw err;
      });
  }

  // Authenticated routes
  static async getProfile() {
    return await authApi
      .get(`/${apiPrefix}/v2/profile`)
      .then((res) => res?.data?.data);
  }

  static async updateProfile(formData) {
    return await authApi
      .post(`/${apiPrefix}/v2/profile`, formData)
      .then((res) => res?.data?.data);
  }

  static async updatePassword(data) {
    return await authApi
      .post(`/${apiPrefix}/v2/update-password`, data)
      .then((res) => res?.data?.data);
  }

  

  // Authenticated routes
  static async getTodayRoutines(params = {}) {
    return await authApi
      .get(`/${apiPrefix}/v2/getTodayRoutine`, {
        params: params,
      })
      .then((res) => res?.data?.data);
  }

  static async getDashboardInfo(params = {}) {
    return await authApi
      .get(`/${apiPrefix}/v2/dashboard`, {
        params: params,
      })
      .then((res) => res?.data?.data);
  }
  static async getMyreports(params = {}) {
    return await authApi
      .get(`/${apiPrefix}/v2/get-reports`, {
        params: params,
      })
      .then((res) => res?.data?.data);
  }

  static async allAdmittedCourse() {
    return await authApi
      .get(`/${apiPrefix}/v2/courses/all`)
      .then((res) => res?.data?.data);
  }

  static async getPositions(params) {
    return await authApi
      .get(`/${apiPrefix}/v2/result-position`, { params })
      .then((res) => res?.data?.data)
      .catch((err) => {
        console.error("Failed to fetch positions:", err);
        throw err;
      });
  }
  static async getResult(params) {
    return await authApi
      .get(`/${apiPrefix}/v2/results`, { params })
      .then((res) => res?.data?.data)
      .catch((err) => {
        console.error("Failed to fetch positions:", err);
        throw err;
      });
  }

  static async couponApplied(formData) {
    return await authApi
      .post(`/${apiPrefix}/v2/coupon applied`, formData)
      .then((res) => res?.data.data);
  }

  static async getVdoOtp(videoId) {
    return await authApi
      .get(`/${apiPrefix}/v2/vdocipher/otp/${videoId}`)
      .then((res) => res?.data)
      .catch((err) => {
        console.error("Error fetching VdoCipher OTP:", err);
        return null;
      });
  }

  static async getNotifications(params = {}) {
    return await authApi
      .get(`/${apiPrefix}/v2/notifications`, { params })
      .then((res) => res?.data?.data);
  }

  static async markNotificationAsRead(notificationUserId) {
    return await authApi
      .post(`/${apiPrefix}/v2/notifications/read`, {
        notification_user_id: notificationUserId,
      })
      .then((res) => res?.data?.data);
  }

  static async markAllNotificationAsRead(notificationUserId) {
    return await authApi
      .post(`/${apiPrefix}/v2/notifications/read/all`, {
        notification_user_id: notificationUserId,
      })
      .then((res) => res?.data?.data);
  }

  static async getMissedClass(page = 1, perPage = 10) {
    return await authApi
      .get(`/${apiPrefix}/v2/missed-class`, {
        params: { page, per_page: perPage },
      })
      .then((res) => res?.data?.data)
      .catch((error) => {
        console.error("Error fetching missed-class:", error);
        return [];
      });
  }

  static async getMissedExam(page = 1, perPage = 10) {
    return await authApi
      .get(`/${apiPrefix}/v2/missed-exam`, {
        params: { page, per_page: perPage },
      })
      .then((res) => res?.data?.data)
      .catch((error) => {
        console.error("Error fetching missed-class:", error);
        return [];
      });
  }
}

export default UserService;
